import { request } from "services/request";
import { outputIndexesGroupingTypesEnum, outputIndexesPeriodTypesEnum } from "constants/cargorunIndexes";

const resource = "api/cargorunIndexes";

export type OutputIndexesPeriodType = (typeof outputIndexesPeriodTypesEnum)[keyof typeof outputIndexesPeriodTypesEnum];

export type OutputIndexesGroupingType =
    (typeof outputIndexesGroupingTypesEnum)[keyof typeof outputIndexesGroupingTypesEnum];

export type CargorunIndexTrailerFamilyType = "Tent" | "Refrigerator";

export interface CargorunIndexDate {
    date: string;
    index: number;
    median: number;
    mean: number;
    count: number;
}

export interface CargorunIndexForPeriod {
    weekDifferences?: number | null;
    monthDifferences?: number | null;
    yearDifferences?: number | null;
    index: number;
    median: number;
    mean: number;
    count: number;
}

export interface CargorunIndexesResponse {
    lastSevenDaysIndex: CargorunIndexForPeriod | null;
    dates: CargorunIndexDate[];
    weekDifferences?: number | null;
    monthDifferences?: number | null;
    yearDifferences?: number | null;
}

export interface CargorunAverageRatesByDestinationDate {
    date: string;
    count: number;
    min: number;
    percentile25: number;
    median: number;
    percentile75: number;
    max: number;
    mean: number;
}

export interface CargorunAverageRatesByDestinationForPeriod {
    weekDifferences?: number | null;
    monthDifferences?: number | null;
    yearDifferences?: number | null;
    count: number;
    min: number;
    percentile25: number;
    median: number;
    percentile75: number;
    max: number;
    mean: number;
}

export interface CargorunAverageRatesByDestinationResponse {
    lastSevenDaysRate: CargorunAverageRatesByDestinationForPeriod | null;
    dates: CargorunAverageRatesByDestinationDate[];
    weekDifferences?: number | null;
    monthDifferences?: number | null;
    yearDifferences?: number | null;
    distance?: number | null;
}

interface GetCargorunIndexesParams {
    periodType: OutputIndexesPeriodType;
    groupingType: OutputIndexesGroupingType;
    trailerFamilyType: CargorunIndexTrailerFamilyType | null;
    isVatTop: boolean;
}

interface GetAverageRatesByDestinationParams {
    fromId: number;
    toId: number;
    periodType: OutputIndexesPeriodType;
    groupingType: OutputIndexesGroupingType;
    trailerFamilyType: CargorunIndexTrailerFamilyType;
    isVatTop: boolean;
}

export function getCargorunIndexes(
    params: GetCargorunIndexesParams,
): Promise<CargorunIndexesResponse | false | undefined> {
    const query = new URLSearchParams({
        periodType: params.periodType,
        groupingType: params.groupingType,
        minOutputsCount: "5",
        isVatTop: String(params.isVatTop),
    });

    if (params.trailerFamilyType) {
        query.set("trailerFamilyType", params.trailerFamilyType);
    }

    return request(`${resource}/getIndexes?${query.toString()}`, { method: "GET" });
}

export function getAverageRatesByDestination(
    params: GetAverageRatesByDestinationParams,
): Promise<CargorunAverageRatesByDestinationResponse | false | undefined> {
    const query = new URLSearchParams({
        fromId: String(params.fromId),
        toId: String(params.toId),
        periodType: params.periodType,
        groupingType: params.groupingType,
        minOutputsCount: "5",
        trailerFamilyType: params.trailerFamilyType,
        isVatTop: String(params.isVatTop),
    });

    return request(`${resource}/getAverageRatesByDestination?${query.toString()}`, { method: "GET" });
}
